<template>
    <div class="col-md-12">
        <b-form-row v-for="(item, index) in form" :key="index">

            <!-- Comparacion por dia -->
            <b-form-group
                label="Seleccione dia"
                class="col-md-3" v-if="type==='day' || type==='source' && rowData.parent == 'day'">
            <b-form-datepicker 
                locale="es" 
                reset-button 
                size="sm" 
                v-model="item.date"/>
            </b-form-group>

            <!-- Comparacion por semana -->
            <b-form-group
                 label="Año"
                class="col-md-1"
                v-if="type==='week' || type==='source' && rowData.parent == 'week'">
                <b-form-select 
                    size="sm" 
                    v-model="item.year"
                    :options="years"
                    @change="getWeeks(index)">
                </b-form-select>
            </b-form-group>

            <b-form-group
                label="Seleccione semana"
                class="col-md-4"
                v-if="type==='week' || type==='source' && rowData.parent == 'week'">
                <b-form-select 
                    size="sm" 
                    v-model="item.date"
                    :options="item.weeks">
                </b-form-select>
            </b-form-group>

            <!-- Comparacion por mes -->
            <b-form-group
                label="Seleccione mes"
                class="col-md-2"
                v-if="type === 'month'">
                <b-form-select 
                    size="sm" 
                    v-model="item.date"
                    :options="optionsMonths">
                </b-form-select>
            </b-form-group>

            <b-form-group 
                class="col-md-2"
                v-if="type === 'month' || type==='source' && rowData.parent == 'month'">
                <b-form-select 
                    size="sm" 
                    v-model="item.year"
                    :options="optionsYears">
                </b-form-select>
            </b-form-group>

            <!-- si se compara por punto de venta, proveedor etc..-->
            <b-form-group
                label="Año"
                class="col-md-2"
                v-if="type==='source' && rowData.parent == 'year'">
                <b-form-select 
                    size="sm" 
                    v-model="item.year"
                    :options="years">
                </b-form-select>
            </b-form-group>

            <b-form-group
                :label="sourceLabel"
                class="col-md-4"
                v-if="type==='source'">
                <multiselect 
                    v-model="item.source"
                    :options="optionsSource()"
                    size="small"
                    track-by="value"
                    label="text">
                    <span slot="noResult">Oops! No se encontraron resultados.</span>
                    <template v-slot:clear >
                        <div class="multiselect__clear" @click="item.source = []"></div>
                    </template>
                </multiselect>
            </b-form-group>

            <!-- Buttons sections -->
            <b-form-group class="col-md-1 mr-2" label="Acciones">
                <b-button 
                    size="sm"
                    variant="success" 
                    type="button"
                    class="mr-1"
                    @click="addRow()">
                    <md-icon icon="add"/>
                </b-button>
                <b-button 
                    size="sm"
                    variant="danger" 
                    type="button" 
                    @click="remoteRow(index)">
                    <md-icon icon="delete"/>
                </b-button>
            </b-form-group>
            <!-- End buttons sections -->
        </b-form-row> 
    </div>   
</template>

<script>
    import moment from 'moment'
    import api from "../../../../../api.js";
    import Multiselect from 'vue-multiselect';

    export default {
        components: { Multiselect },
        props: {
            rowData: {
                type: Object,
                required: true
            },
            sourceCriteria: {
                type: String
            }
        },
        data() {
            
            const defaultFormData = [{
                date: '',
                year: null,
                weeks: []
            }];

            return {
                form: defaultFormData,
                selectedYear: new Date().getFullYear(), // Año inicial
                selectedWeek: null, // Semana seleccionada
                weeks: [], // Opciones de semana
                years: [], // Opciones de año
                weeksWithDates: []
            }
        },
        methods: {
            getWeeksOptions() {
                api(this)
                .get(`/reports/weeks`)
                .then(res => { 
                    this.weeksWithDates = res.data
                    const years   = Object.keys(res.data)
                    const reverse = years.reverse()
                    this.years    = reverse
                })
                .catch(error => { 
                    this.$root.handleRequestError(error) 
                })
                .finally(() => { 
                    this.loading = false
                })
            },
            getWeeks(index) {
                const year = this.form[index].year
                let weeks  = this.weeksWithDates[year]
                weeks = weeks.map(element => {
                    return {value: element.week, text: element.label}
                })
                this.$set(this.form[index], 'weeks', weeks || []);
            },
            optionsSource() {
                if (this.rowData.type === 'source') {
                    if (this.sourceCriteria === 'sales_channels') {
                        return this.getSalesChannelOpts()
                    }
                    if (this.sourceCriteria === 'suppliers') {
                        return this.suppliersOpts()
                    }
                    if (this.sourceCriteria === 'points_of_sales') {
                        return this.pointOfSalesOpts()
                    }

                    if (this.sourceCriteria === 'destinations') {
                        return this.zonesOptions()
                    }
                }
            },
            getSalesChannelOpts() {
                let aux= [...this.$root.auxVars.salesChannelsOpts.map((sc) => ({
                    value: sc.id,
                    text: sc.code,
                }))];
                return aux;
            },
            pointOfSalesOpts() {
                let aux = [...this.$root.auxVars.pointOfSalesOpts.map((pos) => ({
                value: pos.id,
                text: pos.codename,
                }))];
                return aux;
            },
            zonesOptions() {
                let aux= [...this.$root.auxVars.masterZonedAreasOpts.map((zam) => ({
                value: zam.id,
                text: zam.name,
                }))];
                return aux;

            },
            suppliersOpts(){
                let aux= [...this.$root.auxVars.suppliersOpts.map((sp) => ({
                value: sp.id,
                text: sp.name,
                }))];
                return aux;
            },
            addRow() {
                this.form.unshift({
                    date: '',
                    year: null,
                    weeks: []
                })
            },
            remoteRow(index) {
                if (this.form.length >= 2) {
                    this.form.splice(index, 1)
                }
            }
        },
        computed: {
            type() {
                return this.rowData.type
            },
            sourceLabel() {
                if (this.sourceCriteria == 'sales_channels') {
                    return 'Canal de venta'
                }

                if (this.sourceCriteria == 'suppliers') {
                    return 'Proveedor'
                }

                if (this.sourceCriteria == 'points_of_sales') {
                    return 'Punto de venta'
                }

                if (this.sourceCriteria == 'destinations') {
                    return 'Destino'
                }

                return '--indefinido'
            },
            optionsYears() {
                const startYear = 2020
                const limit     = moment().add(3, 'y').format('YYYY')
                let optionsYears = []
                for (let index = limit; index >= (startYear); index--) {
                    optionsYears.push(index)
                }
                return optionsYears
            },
            optionsMonths() {
                return [
                    {value:1 , text:"Enero"},
                    {value:2 , text:"Febrero"},
                    {value:3 , text:"Marzo"},
                    {value:4 , text:"Abril"},
                    {value:5 , text:"Mayo"},
                    {value:6 , text:"Junio"},
                    {value:7 , text:"Julio"},
                    {value:8 , text:"Agosto"},
                    {value:9 , text:"Septiembre"},
                    {value:10, text:"Octubre"},
                    {value:11, text:"Noviembre"},
                    {value:12, text:"Diciembre"},
                ]
            },
        },
        mounted() {
            this.getWeeksOptions();
        },
    }
</script>